<template>
    <div class="container-vocal">
        <audio ref="audioPlayer" :src="src" preload="metadata" @loadedmetadata="onLoadedMetadata" @timeupdate="onTimeUpdate" @ended="onEnded"></audio>

        <div class="vocal-player">
            <div class="vocal-play-btn" @click="togglePlay">
                <i :class="isPlaying ? 'fa-solid fa-pause' : 'fa-solid fa-play'"></i>
            </div>

            <div class="vocal-progress" @click="seek">
                <div class="vocal-progress-bar" :style="{ width: progress + '%' }"></div>
            </div>

            <span class="vocal-duration">{{ formattedTime }}</span>

            <i v-if="deletable" class="fa-regular fa-xmark" @click="$emit('delete')"></i>
        </div>

        <template v-if="transcript">
            <span v-if="showTranscript" class="vocal-transcript">{{ transcript }}</span>
            <span v-else class="btn-vocal-transcript" @click="showTranscript = true">Afficher la retranscription</span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        src: { type: String, required: true },
        transcript: { type: String, default: '' },
        deletable: { type: Boolean, default: false },
    },

    data() {
        return {
            isPlaying: false,
            progress: 0,
            formattedTime: '0:00',
            showTranscript: false,
        }
    },

    methods: {
        formatTime(seconds) {
            if (!isFinite(seconds) || isNaN(seconds)) return null;
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
            return `${mins}:${secs}`;
        },

        onLoadedMetadata() {
            const audio = this.$refs.audioPlayer;
            if (!audio) return;
            const formatted = this.formatTime(audio.duration);
            if (formatted) this.formattedTime = formatted;
        },

        togglePlay() {
            const audio = this.$refs.audioPlayer;
            if (!audio) return;
            if (this.isPlaying) {
                audio.pause();
                this.isPlaying = false;
            } else {
                audio.play();
                this.isPlaying = true;
            }
        },

        onTimeUpdate() {
            const audio = this.$refs.audioPlayer;
            if (!audio || !isFinite(audio.duration)) return;
            this.progress = (audio.currentTime / audio.duration) * 100;
            this.formattedTime = this.formatTime(audio.currentTime) || '0:00';
        },

        onEnded() {
            this.isPlaying = false;
            this.progress = 0;
            const audio = this.$refs.audioPlayer;
            if (audio) this.formattedTime = this.formatTime(audio.duration) || '0:00';
        },

        seek(e) {
            const audio = this.$refs.audioPlayer;
            if (!audio || !audio.duration) return;
            const ratio = e.offsetX / e.currentTarget.offsetWidth;
            audio.currentTime = ratio * audio.duration;
        },
    },
}
</script>

<style lang="scss" scoped>
    .container-vocal {
        margin-top: 8px;

        .vocal-player {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 12px;
            background: #efefef;
            border-radius: 9px;
            border: 1px solid #ababab1a;
            

            .vocal-play-btn {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background: #121826;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                flex-shrink: 0;
                transition: opacity 0.15s;

                &:hover { opacity: 0.8; }

                i { font-size: 12px; }
            }

            .vocal-progress {
                flex: 1;
                height: 4px;
                background: #ddd;
                border-radius: 2px;
                cursor: pointer;
                position: relative;

                &:hover { background: #ccc; }

                .vocal-progress-bar {
                    height: 100%;
                    background: #121826;
                    border-radius: 2px;
                    transition: width 0.1s linear;
                    pointer-events: none;
                }
            }

            .vocal-duration {
                font-size: 13px;
                color: #888;
                min-width: 36px;
                text-align: right;
                font-variant-numeric: tabular-nums;
            }

            .fa-xmark {
                color: #aaa;
                cursor: pointer;
                font-size: 16px;
                transition: color 0.15s;

                &:hover { color: #121826; }
            }
        }

        .vocal-transcript {
            display: block;
            margin-top: 8px;
            font-size: 13px;
            color: #666;
            font-style: italic;
            line-height: 1.5;
            padding-left: 12px;
            border-left: 2px solid #ddd;
        }
        .btn-vocal-transcript {
            display: block;
            margin-top: 6px;
            font-size: 13px;
            color: #666;
            line-height: 1.5;
            cursor: pointer;
            
            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>